import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import {
  LOAD_OFFERS,
  DL_PAGE_LOADED
} from './showOffersFilter';
import {
  offersFlowTypeSelector,
  enableDefaultLobsSelector,
  updateFilter,
  dlDisplayedOffersSelector,
  dlFilterOptionSelected,
  showInternetOffers
} from '../../../data/offers/offers';
import {
  lobSelector
} from '../../../data/plan/plan';
import {
  logCustomEvent
} from '../../../dataLayer/dataLayer';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  setFlowType
} from '../../../common/common';

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_OFFERS, loadContentWorker);
}

// WORKERS
export function* loadContentWorker() {
  const state = yield select();

  if (!_.isEmpty(state.offers.offerData)) {
    yield put({
      type: DL_PAGE_LOADED
    });
    yield put(hideGlobalSpinner());
    return;
  }

  try {
    yield put(showGlobalSpinner({hideContent: true, initiator: 'myplan load'}));

    const state = yield select();
    const rawQueryString = _.get(state, 'routing.locationBeforeTransitions.search');
    const queryString = _.trimStart(rawQueryString, '?'); //current implementation assumes ? character so removing from the start of the query string

    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'context'},
      [{state: 'plan'}, {state: 'equipment'}],
      {state: 'offers', param: queryString}
    ]);

    if (!success) {
      return;
    }

    const lobData = yield select(lobSelector);

    yield delay(0); // HACK: Something is causing the saga not to execute on time - action fires, selector doesn't see state update
    const enableDefaultLobs = yield select(enableDefaultLobsSelector);

    // TODO: Refactor
    // for lack of a better implementation, looping over lobs and firing a separate action for each lob
    // should create an action creator that takes an array or an object?
    // need to use a for loop because yield doesn't work inside another function

    if (!enableDefaultLobs) {
      for (let i=0; i < lobData.length; i++) {
        lobData[i].subscribed ? yield put(updateFilter(true, i)) : null;
     }}

    const flowType = yield select(offersFlowTypeSelector);

    yield put(setFlowType(flowType));

    // HACK: selector and updateFilter are a hack to select internet when there are no TV offers
    // remove when showInternetOffers selector is removed
    const selectInternetOffers =  yield select(showInternetOffers);

    if (selectInternetOffers) {
      const internetIndex = _.findIndex(lobData, {lobName: 'Internet'});

      yield put(updateFilter(true, internetIndex));
    }

    yield put(hideGlobalSpinner());
    yield put({
      type: DL_PAGE_LOADED
    });

    const offersData = yield(select(dlDisplayedOffersSelector));
    const filterOptionSelected = yield(select(dlFilterOptionSelected));

    yield put(logCustomEvent({
      eventName: "Offer Loaded",
      eventAction: "product view",
      type: "page load",
      eventMethod: "product-View",
      product: offersData.map((offer) => ({
        productInfo: {...offer}
      })),
      page: {
        attributes: {
          filterOptionSelected: filterOptionSelected
        }
      }
    }));
  } catch(e) {
    yield put(hideGlobalSpinner());
    browserHistory.push(navigationRoutes[navigationSteps.myPlan.ERROR].path);
  }
}

export default function* offersSagas() {
  yield [
    fork(loadContentWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/showOffers/showOffersFilterSagas.js
 **/